import styled from 'styled-components';
import { Autocomplete } from '@attain-sre/attain-design-system';

export const SearchArea = styled.div`
  position: sticky;
  top: 64px;
  z-index: 999;
  background: white;
  padding: 16px;
  border-bottom: 1px solid rgb(205, 199, 209);

  display: flex;
  flex-wrap: wrap;
  align-items: center;

  > * {
    flex-shrink: 0;
  }
`;

export const SelectAutoCompletePlatform = styled(Autocomplete)`
  width: 170px;
  display: inline-flex;
  & input {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
`;

export const SelectAutoCompletePlatformType = styled(Autocomplete)`
  width: 170px;
  display: inline-flex;
  margin-left: 10px;
  & input {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
`;

export const SegmentName = styled.div`
  margin-left: 0px;
  font-size: 16px;
  max-width: 350px;
  text-align: start;
  display: inline-block;
  cursor: pointer;
  font-family: Calibre-Regular, sans-serif;
  /* Allow text wrapping (no ellipsis) */
  white-space: normal;
  line-height: 1.4;
  text-overflow: clip;
  overflow: visible;
  height: auto;
`;

export const NumberCell = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  text-align: right;
`;

export const CurrencyCell = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  text-align: right;
`;

export const LastUpdated = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  text-align: right;
`;

export const SearchTextField = styled.div`
  width: 300px;
  margin-right: 10px;
`;

export const SelectAutoCompleteGroupOptions = styled.li`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  word-break: break-all;
`;

export const LastSyncedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
`;

export const LastSyncedLabel = styled.div`
  font-size: 14px;
  font-family: Calibre-Regular, sans-serif;
  color: rgb(128, 128, 128);
  line-height: 16px;
  margin-bottom: 2px;
`;

export const LastSyncedDate = styled.div`
  font-size: 16px;
  font-family: Calibre-Semibold, sans-serif;
  color: rgb(26, 23, 28);
  line-height: 16px;
`;

export const LastSyncedTime = styled.div`
  color: rgb(26, 23, 28);
  font-family: Calibre-Semibold, sans-serif;
  font-size: 16px;
  line-height: 16px;
`;

// Remodeling Table Styles
export const StatusContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const StatusIndicator = styled.span<{ $status: 'live' | 'error' }>`
  background: ${({ $status }) =>
    $status === 'live' ? 'rgb(76, 175, 80)' : 'rgb(244, 67, 54)'};
  border-radius: 50%;
  display: inline-block;
  height: 8px;
  width: 8px;
`;

export const StatusText = styled.span`
  color: rgb(26, 23, 28);
  font-family: Calibre-Regular, sans-serif;
  font-size: 14px;
`;

export const DateCell = styled.div`
  font-family: Calibre-Regular, sans-serif;
  font-size: 16px;
  font-weight: 300;
`;

/** Link that opens Audience Studio editor in a new tab (Audience ID column in Remodeling table) */
export const EditAudienceLink = styled.a`
  color: #1976d2;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
